@if (matIcon) {
  <mat-icon [ngClass]="class">{{ matIcon }}</mat-icon>
} @else if (faIcon) {
  <i [ngClass]="[faStyleClass, 'fa-' + faIcon, class]"></i>
} @else {
  <mat-icon [ngClass]="class" [svgIcon]="icon"></mat-icon>
}
